module.exports = __webpack_public_path__ + "static/img/close.35c5bf.svg";